import React from 'react';

import { TOTPResult } from '@/hooks/useTOTP';

interface Props {
  readonly totp: TOTPResult;
  readonly action: string | undefined;
}

export const Enable2FAForm: React.FC<Props> = (props: Props): React.ReactElement => {
  const { action, totp } = props;

  if (!action) {
    return <></>;
  }

  return (
    <>
      <input type="hidden" name="action" value="create" />
      <input type="hidden" name="secret" value={totp.secret} />
      <input type="hidden" name="digits" value={totp.digits} />
      <input type="hidden" name="period" value={totp.period} />
      <input type="hidden" name="algorithm" value={`Hmac${totp.algorithm}`} />
    </>
  );
};
